module.exports = __webpack_public_path__ + "Flama-UltralightItalic.woff?dbb9b77d836e20a4462f5dfb4b21a026";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-UltralightItalic.woff
// module id = 885
// module chunks = 0